import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import { Card, Button } from './'

function SimplePagination({ next_id = null, prev_id = null, setFrom_id }) {
    return (
        <div className="pt-6 grid xl:grid-cols-3 justify-items-center">
            <Card spacing="md" shadow="md" bordered className="xl:col-start-2 ">
                <div className="flex justify-center">
                    <Button
                        hoverColor={prev_id ? 'lighter' : 'transparent'}
                        onClick={() => setFrom_id?.(prev_id)}
                        disabled={!prev_id}
                    >
                        <BsArrowRightShort className="text-2xl" />
                    </Button>
                    <Button
                        hoverColor={next_id ? 'transparent' : 'lighter'}
                        onClick={() => setFrom_id?.(next_id)}
                        disabled={!next_id}
                    >
                        <BsArrowLeftShort className="text-2xl" />
                    </Button>
                </div>
            </Card>
        </div>
    )
}
export default SimplePagination
